import * as React from 'react';
import { withStyles, WithStyles, CircularProgress, Theme } from '@material-ui/core';
import Portal from '@material-ui/core/Portal/Portal';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { Dispatch, connect } from 'react-redux';
import { StoreState } from '../../store';

//#region UI configuration
const styles = (theme: Theme) => ({
    container: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        zIndex: 1300,
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'center'
    } as CSSProperties,
    background: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        position: 'fixed',
        willChange: 'opacity',
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    } as CSSProperties,
    progress: {
        flex: '0 1 auto',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        width: 100,
        height: 100,
        background: theme.palette.common.white,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center'
    } as CSSProperties
});

type Styles = WithStyles<'container' | 'background' | 'progress'>;
//#endregion

//#region Props & State
interface LoadingStateProps {
    readonly showLoading: boolean;
}
interface LoadingDispatchProps { }
interface LoadingProps extends LoadingStateProps, LoadingDispatchProps { }
interface LoadingState { }

type PropsWithStyles = LoadingProps & Styles;
//#endregion

class Loading extends React.Component<PropsWithStyles, LoadingState> {

    render() {
        const { classes, showLoading } = this.props;

        if (showLoading) {
            return (
                <Portal>
                    <div className={classes.container}>
                        <div className={classes.background} />
                        <div className={classes.progress}>
                            <CircularProgress />
                        </div>
                    </div>
                </Portal>
            );
        } else {
            return null;
        }
    }
}

//#region Connect
const mapStateToProps = (state: StoreState): LoadingStateProps => ({
    showLoading: state.ongoingActions > 0
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({});

export default connect<LoadingStateProps, LoadingDispatchProps>(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)<LoadingProps>(Loading)
);
//#endregion



// WEBPACK FOOTER //
// ./src/modules/app/Loading.tsx